const ua = navigator.userAgent

/**
 * @method 获取本地assets静态文件
 * @param path 
 * @returns 
 */
export function getImageUrl(path) {
  return require(`../assets/${path}`)
}

/**
 * @method 是否Android系统
 * @returns {boolean}
 */
export function isAndroid() {
  return /Android|Linux/.test(ua)
}

/**
 * @method 是否IOS系统
 * @returns {boolean}
 */
export function isIOS() {
  return /iPhone|Mac OS X|iPad/.test(ua)
}

/**
 * @method 是否微信浏览器内
 * @returns {boolean}
 */
export function isWeixin() {
  return /micromessenger/i.test(ua)
}
